import { render, staticRenderFns } from "./ImportInfo.vue?vue&type=template&id=784a87c4&scoped=true"
import script from "./ImportInfo.vue?vue&type=script&lang=js"
export * from "./ImportInfo.vue?vue&type=script&lang=js"
import style0 from "./ImportInfo.vue?vue&type=style&index=0&id=784a87c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a87c4",
  null
  
)

export default component.exports